import React, { useContext, useRef } from 'react';
import TickGreen from '../../../../../Assets/Modals/TickGreen.svg';
import { useDispatch, useSelector } from 'react-redux';
import { deleteCoupon } from '../../../../../lib/utils/apiCalls';
import { showToast } from '../../../../../Components/Toaster/Toaster';
import { useOutsideClickHandler } from '../../../../../Hooks/useOutsideClick';
import { toast } from 'react-toastify';
import { CouponContext } from '../../../../../Context/Coupons/CouponContext';
import { closeListModal, fetchCoupons } from '../../../../../Features/couponsSlice';

function DeleteConfirmation() {
    const dispatch = useDispatch();
    const wrapperRef = useRef(null);

    useOutsideClickHandler(wrapperRef, () => {
        dispatch(closeListModal());
    });

    const { selectedCoupons, setSelectedCoupons } = useContext(CouponContext);

    const selectedKebabItem = useSelector((state) => state.coupons.selectedKebabItem);

    const handleCancelClick = () => {
        dispatch(closeListModal());
    }

    const handleDeleteClick = async () => {
        if (selectedCoupons.length > 0) {
            const deletePromises = selectedCoupons.map(item => deleteCoupon(item, { id: item }));

            const deleteAllPromise = Promise.all(deletePromises);
    
            toast.promise(
                deleteAllPromise,
                {
                    pending: {
                        render() {
                            return 'Deleting selected coupons...';
                        },
                        className: 'toast-pending',
                    },
                    success: {
                        render() {
                            return 'Coupons deleted.';
                        },
                    },
                }
            );

            try {
                await deleteAllPromise;
                dispatch(closeListModal());
                setSelectedCoupons([]);
                dispatch(fetchCoupons());
            }
            catch (err) {
                showToast('Failed to delete some or all coupons. Please try again.', 'error');
            }
        }
        else {
            try {
                const response = await deleteCoupon(selectedKebabItem.id, { id: selectedKebabItem.id });

                if (response?.status === 200) {
                    showToast('Coupon deleted.', 'success');
                    dispatch(closeListModal());
                    dispatch(fetchCoupons());
                }
                else {
                    showToast('Error deleting coupon.', 'error');
                }
            }
            catch (err) {
                showToast('Error deleting coupon.', 'error');
            }
        }
    };

    return (
        <div ref={wrapperRef} className="w-[38%] h-fit bg-[#FFFFFF] rounded-xl p-6 flex flex-col gap-6 shadow-[0px_0px_12px_0px_#0000003D]">
            <div className="flex gap-3">
                <div className="size-12 flex items-center justify-center bg-[#D1FAE5] rounded-full">
                    <div className="size-6 flex items-center justify-center">
                        <img src={TickGreen} alt="" />
                    </div>
                </div>

                <div className="flex flex-col gap-4 w-[calc(100%-48px)]">
                    <div className="flex flex-col gap-2">
                        <h1 className='font-semibold text-[18px] leading-6 text-[#121212]'>Delete Coupon</h1>

                        <p className='font-normal text-[14px] leading-5 text-[#666666]'>Are you sure you want to delete {selectedCoupons.length > 0 ? 'coupons' : 'this coupon'}? All coupon data will be permanently removed from our servers forever. This action cannot be undone.</p>
                    </div>

                    <div className="flex justify-end gap-3 font-medium font-inter">
                        <button onClick={handleCancelClick} className='text-[14px] leading-5 text-[#374151] rounded-md px-[17px] py-[9px] bg-[#FFFFFF] border border-[#D1D5DB] shadow-[0px_1px_2px_0px_#0000000D]'>Cancel</button>

                        <button onClick={handleDeleteClick} className='text-[14px] leading-5 text-[#FFFFFF] rounded-md px-[17px] py-[9px] bg-[#DC2626] shadow-[0px_1px_2px_0px_#0000000D]'>Delete</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DeleteConfirmation;
